import { useContext } from 'react';
import { checkScopes } from './check_scopes';
import { AuthContext } from '../../contexts';
/**
 * Returns true if the identity has `permission` on `resource`, OR on any
 * descendant matching `${resource}/${descendantSegment}/...`.
 *
 * Use when scopes are granted at a deeper resource level than the route being
 * checked (e.g. `content.consent.list` granted on environments must satisfy a
 * study-level nav item). `checkScopes` upward propagation cannot resolve this
 * when the scope path lacks the permission's `appliesTo` segment.
 */
export const useScopeValidatorOnDescendant = (permission, { resource, descendantSegment }) => {
    const { user, scopes } = useContext(AuthContext);
    if (!user || !scopes) {
        return false;
    }
    if (checkScopes({ scopes, permission, resource })) {
        return true;
    }
    const allowedResources = scopes[permission] ?? [];
    const descendantPrefix = `${resource}/${descendantSegment}/`;
    return allowedResources.some((allowedResource) => {
        const normalized = allowedResource.endsWith('/*') ? allowedResource.slice(0, -2) : allowedResource;
        return normalized.startsWith(descendantPrefix);
    });
};
